import { library } from '@fortawesome/fontawesome-svg-core';

import { faAngleDown } from '@fortawesome/free-solid-svg-icons/faAngleDown';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faStar } from '@fortawesome/free-solid-svg-icons/faStar';

library.add(faAngleDown, faCheckCircle, faSpinner, faPlus, faStar);
